// analytics
import DTM from 'shared/helpers/DTM';

export const trackReviewSummaryClick = () => {
  DTM.track('view-review-summary');
};
